import { Card, Tabs, Table, Row, Col, Tag, Form, Input, Button, Dropdown, Menu, Upload, Progress, Modal, Skeleton, Select, Image, Space, List, Divider, InputNumber, DatePicker, Carousel } from "antd";
import "react-responsive-carousel/lib/styles/carousel.min.css";

import React, { useEffect, useState, useCallback, useRef } from "react";
// import Clock from 'react-live-clock';
import { formatCurrency } from '../common/Format'
import {
    AppstoreOutlined, SettingOutlined, DeleteOutlined, FormOutlined, CloseCircleOutlined, PlusOutlined, BgColorsOutlined,
    MenuOutlined,
} from "@ant-design/icons";
import swal from "sweetalert";

import 'moment/locale/vi';
import { HexColorPicker, } from "react-colorful";

import ButtonGroup from "antd/lib/button/button-group";
import moment from "moment";
import axiosClient from "../../api/axios";
import { changeUpload, updateFileListFromUrls, uploadImage, beforeUpload, getFilePreview } from '../common/Upload/upload.js'
import limitString from "../common/LimitString/litmitstring";
import LinkUpload from "../../api/LinkUpload";
import { FaMapMarkedAlt } from "react-icons/fa";
import { SiZalo } from "react-icons/si";
import { FaFacebook } from "react-icons/fa6";

const { TabPane } = Tabs;
const { Option } = Select;
const CompanyManager = () => {
    const [progress, setProgress] = useState(0);

    const database = localStorage.getItem('DatabaseName');
    const token = localStorage.getItem('token');
    const IDAccount = localStorage.getItem('ID');
    const header = {
        "Content-Type": "application/json",
        Accept: "application/json",
        Authorization: `Bearer ${token}`,
    };

    const [formOwners] = Form.useForm();
    const [formFilterOwners] = Form.useForm()
    // Quản lý banner
    const [dataOwners, setDataOwners] = useState([]);
    const [openModalOwners, setOpenModalOwners] = useState(false);
    const [loadingOwners, setLoadingOwners] = useState(false);
    const [statusOwners, setStatusOwners] = useState(false);


    // upload image
    const [fileListOwners, setFileListOwners] = useState([]);



    const changeUploadOwners = async ({ fileList }) => {
        const dataImage = fileList.map(r => `/Uploads/${database}/` + database + '/' + r.name);
        setFileListOwners(fileList);
        const resultURL = dataImage.join(";");
        formOwners.setFieldsValue({
            Logo: resultURL,
        })
    };




    const uploadImage = async options => {
        const { onSuccess, onError, file, onProgress } = options;
        const fmData = new FormData();
        const config = {
            headers: {
                "content-type": "multipart/form-data",
                Accept: "application/json",
                Authorization: `Bearer ${token}`,
            },
            onUploadProgress: event => {
                const percent = Math.floor((event.loaded / event.total) * 100);
                setProgress(percent);
                if (percent === 100) {
                    setTimeout(() => setProgress(0), 1000);
                }
                onProgress({ percent: (event.loaded / event.total) * 100 });
            }
        };

        const filenew = new File([file], file.name, {
            type: 'image/png'
        });
        fmData.append("image", filenew);
        try {

            const res = await axiosClient.post(
                `/uploadfile?subDirectory=${database}`,
                fmData,
                config
            );
            onSuccess("Ok");
            console.log("server res: ", res);
            if (res.status === 200) {
                setProgress(0)
            }

        } catch (err) {
            console.log("Eroor: ", err);
            const error = new Error("Some error");
            onError({ err });
        }

    };

    const showModalOwners = (record) => {
        //const IDTemp = 0;
        setFileListOwners([])
        formOwners.resetFields();
        if (typeof record === 'object') {
            setLoadingOwners(false)
            setStatusOwners(true)
            updateFileListFromUrls(setFileListOwners, record.Logo)

            formOwners.setFieldsValue(record);
            setOpenModalOwners(true)
        }
        else {
            setLoadingOwners(false)
            setStatusOwners(false)
            formOwners.setFieldsValue({
                "ID": 1,
                "OwnerName": "",
                "Address": "",
                "Phone": "",
                "Email": "",
                "Logo": "",
                "Googlemap": "",
                "Zalo": "",
                "Facebook": "",
                Introduction: ""
            })
            setOpenModalOwners(true)
        }


    }
    const base64ToBlob = (base64, contentType = '') => {
        const byteCharacters = atob(base64);
        const byteArrays = [];

        for (let offset = 0; offset < byteCharacters.length; offset += 512) {
            const slice = byteCharacters.slice(offset, offset + 512);
            const byteNumbers = Array.from(slice).map(char => char.charCodeAt(0));
            byteArrays.push(new Uint8Array(byteNumbers));
        }

        return new Blob(byteArrays, { type: contentType });
    };
    function blobToFileListItem(blob, fileName) {
        const fileUrl = URL.createObjectURL(blob); // Tạo URL tạm thời từ Blob
        return {
            uid: Date.now().toString(),  // Tạo một UID duy nhất
            name: fileName || "file",   // Tên file
            status: "done",             // Đặt trạng thái 'done' vì file đã sẵn sàng
            url: fileUrl,               // Gắn URL để xem trước
            originFileObj: blob         // Blob gốc để tải lên
        };
    }

    const fillArrayBanner = (arr) => {
        const list = [];
        arr.map(r => {
            const fileName = String(r).split('/files/')[1]
            axiosClient.get(`/ReadFile?fileName=${fileName}`, { headers: header }).then(resRead => {
                const file = blobToFileListItem(base64ToBlob(resRead.data.base64Content, resRead.data.contentType), fileName);
                list.push(file)
                if (list[0].name === '') {
                    setFileListOwners([])
                }
                else {
                    setFileListOwners(list)
                }
            })
        })
    }

    const onFinishOwners = (values) => {

        setLoadingOwners(true)
        if (statusOwners === false) {
            axiosClient.post('/Owners/AddOwners', values, {
                headers: header
            }).then(res => {
                setLoadingOwners(false)
                swal('Thành công!', {
                    icon: 'success'
                })
                formOwners.resetFields();
                LoadDataOwners();
                setOpenModalOwners(false)
            })
        }
        else {

            axiosClient.post('/Owners/UpdateOwners', values, {
                headers: header
            }).then(res => {
                if (res.status === 200) {

                    setLoadingOwners(false)
                    swal('Thành công!', {
                        icon: 'success'
                    })
                    formOwners.resetFields();
                    LoadDataOwners();
                    setOpenModalOwners(false)
                }
            })
        }

    }

    const LoadDataOwners = () => {
        axiosClient.post('/Owners/GetOwnersAll', '', {
            headers: header
        }).then(res => {
            if (res.status === 200) {
                setDataOwners(res.data);
            }
        })
    }


    const [dataPermission, setDataPermission] = useState([]);
    const LoadDataPermission = () => {
        axiosClient.post('/Permissions/GetApiPermissionAll', '', { headers: header }).then(resPermiss => {
            setDataPermission(resPermiss.data);
        })
    }

    const beforeUpload = (file) => {
        // Tạo file mới với tên mới
        const newFile = new File([file], moment().toDate().valueOf() + `${file.name}`, { type: file.type });
        return newFile;
    };

    const renderOwners = () => {
        return (
            <Form
                id="form-Owners"
                form={formOwners}
                onFinish={onFinishOwners}
                colon={false}
                name="basic"
                labelCol={{
                    span: 24,
                }}
                wrapperCol={{
                    span: 24,
                }}
                initialValues={{
                    remember: true,
                }}
                autoComplete="off"
            >
                <Form.Item hidden name='ID'>
                    <Input />
                </Form.Item>

                <Form.Item rules={[
                    {
                        required: true,
                        message: 'Nhập chủ sở hữu',
                    },
                ]} name='OwnerName' label='Tên chủ sở hữu'>
                    <Input.TextArea />
                </Form.Item>
                <Form.Item rules={[
                    {
                        required: true,
                        message: 'Nhập địa chỉ',
                    },
                ]} name='Address' label='Địa chỉ'>
                    <Input />
                </Form.Item>
                <Form.Item rules={[
                    {
                        required: true,
                        message: "Nhập số điện thoại",

                    },
                ]} name='Phone' label='Số điện thoại'>
                    <Input />
                </Form.Item>
                <Form.Item rules={[
                    {
                        required: true,
                        message: 'Nhập Email',
                        type: 'email'
                    },
                ]} name='Email' label='Email'>
                    <Input />
                </Form.Item>
                <Form.Item name='Googlemap' label='Đường dẫn Googlemap'>
                    <Input.TextArea />
                </Form.Item>

                <Form.Item name='Zalo' label='Đường dẫn Zalo'>
                    <Input.TextArea />
                </Form.Item>
                <Form.Item name='Facebook' label='Đường dẫn Facebook'>
                    <Input.TextArea />
                </Form.Item>
                <Form.Item name='Introduction' label='Giới thiệu tổ chức'>
                    <Input.TextArea />
                </Form.Item>

                <Form.Item name={'Logo'} label='Logo'>
                    <Upload
                        multiple
                        listType="picture-card"
                        customRequest={uploadImage}
                        beforeUpload={beforeUpload}
                        maxCount={1}
                        fileList={fileListOwners}
                        onPreview={(file) => window.open(file.url)}
                        onChange={(info) => changeUpload(formOwners, 'Logo', info, setFileListOwners)}
                        onRemove={(file) => {
                            // Xử lý khi file bị xóa
                            // Ví dụ: Cập nhật lại fileLists sau khi file bị xóa
                            const updatedFileList = fileListOwners.filter(f => f.uid !== file.uid);  // Loại bỏ file bị xóa
                            setFileListOwners(updatedFileList);  // Cập nhật lại danh sách file
                        }}
                    >
                        <Button
                            style={{
                                width: "100%",
                                height: 100,
                                border: "2px dashed #40a9ff",
                                backgroundColor: "#f0faff",
                                borderRadius: 8,
                                display: "flex",
                                flexDirection: "column",
                                alignItems: "center",
                                justifyContent: "center",
                                gap: 5,
                                color: "#1890ff",
                                fontWeight: 500,
                            }}
                        >
                            <PlusOutlined style={{ fontSize: 24 }} />
                            <span>Upload Ảnh</span>
                        </Button>
                    </Upload>
                </Form.Item>
            </Form >
        )
    }


    const columnOwners = [
        {
            title: (
                <div style={{ textAlign: "center", fontSize: 12 }}>
                    Tên tổ chức
                </div>
            ),
            dataIndex: 'Name',
            width: 150,
            render: (text, record) => {
                return (
                    <div style={{ textAlign: "left", fontSize: 12 }}>
                        <Row>
                            <Col span={24}>
                                {record.OwnerName}
                            </Col>

                        </Row>

                    </div>
                );
            },
        },
        {
            title: (
                <div style={{ textAlign: "center", fontSize: 12 }}>
                    Địa chỉ
                </div>
            ),
            dataIndex: 'Zalo',
            width: 150,
            render: (text, record) => {
                return (
                    <div style={{ textAlign: "left", fontSize: 12 }}>
                        {record.Address}
                    </div>
                );
            },
        },
        {
            title: (
                <div style={{ textAlign: "center", fontSize: 12 }}>
                    Email
                </div>
            ),
            dataIndex: 'Zalo',
            width: 120,
            render: (text, record) => {
                return (
                    <div style={{ textAlign: "left", fontSize: 12 }}>
                        {record.Email}
                    </div>
                );
            },
        },
        {
            title: (
                <div style={{ textAlign: "center", fontSize: 12 }}>
                    Số điện thoại
                </div>
            ),
            dataIndex: 'Zalo',
            width: 100,
            render: (text, record) => {
                return (
                    <div style={{ textAlign: "center", fontSize: 12 }}>
                        {record.Phone}
                    </div>
                );
            },
        },
        {
            title: (
                <div style={{ textAlign: "center", fontSize: 12 }}>
                    Đường dẫn
                </div>
            ),
            dataIndex: 'Zalo',
            width: 100,
            render: (text, record) => {
                return (
                    <div style={{ textAlign: "left", fontSize: 12 }}>
                        <Row>
                            <Col span={24}>

                                <FaMapMarkedAlt /> <a href={record.Googlemap} target="_blank" rel="noopener noreferrer">Google Maps</a>
                            </Col>
                            <Col span={24}>
                                <SiZalo /> <a target="_blank" href={`https://zalo.me/${record.Zalo}`}>{record.Zalo}</a>
                            </Col>
                            <Col span={24}>
                                <FaFacebook /> <a href={record.Facebook} target="_blank">Facebook</a>
                            </Col>
                        </Row>
                    </div>
                );
            },
        },


        {
            title: (
                <div style={{ textAlign: "center", fontSize: 12 }}>
                    Logo
                </div>
            ),
            dataIndex: 'Logo',
            width: 100,
            render: (text, record) => {
                const arrImage = String(record.Logo).split(';');
                return (
                    <div style={{ textAlign: "center", fontSize: 12 }}>

                        <Image.PreviewGroup>
                            <Carousel infinite={false} autoplay>
                                {arrImage.filter(Boolean).map(r => (
                                    <Image style={{ width: 40 }} src={LinkUpload(r)} />
                                ))}
                            </Carousel>
                        </Image.PreviewGroup>
                    </div>
                );
            },
        },
        {
            title: (
                <div style={{ textAlign: "center", fontSize: 12 }}>
                    <SettingOutlined />
                </div>
            ),
            width: 100,
            render: (text, record) => {
                return (
                    <div style={{ textAlign: "center", fontSize: 12 }}>
                        <ButtonGroup>
                            <Button disabled={dataPermission.includes('UpdateOwners') ? false : true} icon={<FormOutlined style={{ color: "#33CCFF" }} />} onClick={(e) => showModalOwners(record)}  ></Button>
                            &ensp;
                            {/* <Button
                                disabled={dataPermission.includes('DeleteOwners') ? false : true}
                                onClick={(e) => {
                                    onDeleteOwners(record.ID, e);
                                }}
                                icon={<DeleteOutlined style={{ color: "red" }} />}
                            ></Button> */}
                        </ButtonGroup>
                    </div>
                );
            },
        },
    ]


    useEffect(() => {

        LoadDataPermission()
        LoadDataOwners();

    }, [])


    const handleCancelOwners = () => {
        setLoadingOwners(false);
        setOpenModalOwners(false);
    }
    const handleOkOwners = () => {
        setTimeout(() => {
            setLoadingOwners(false);
            setOpenModalOwners(false);
        }, 3000);
    }


    return (
        <div>
            <Card size="small">
                <Tabs type="card"
                    tabBarGutter={10}
                    tabPosition="top" // Hiển thị tabs theo chiều ngang
                    tabBarStyle={{ backgroundColor: "#D6E4FF", borderRadius: "8px", boxShadow: "0px 2px 6px rgba(0, 0, 0, 0.1)" }}
                    moreIcon={null} >

                    <TabPane tab="Tổ chức" key="1">
                        <Row gutter={16}>
                            <Col span={24}>
                                <Form id="form-filter-Owners" form={formFilterOwners}>
                                    {/* <Row gutter={[8, 8]}>
                                        <Col xs={24} xl={24} span={4}>
                                            <Button hidden={dataPermission.includes('AddOwners') ? false : true} key={1} onClick={(e) => showModalOwners(0, e)} style={{ backgroundColor: '#00CC99', color: 'white', minWidth: 100, borderRadius: 5 }} icon={<PlusOutlined style={{ color: 'white' }} />}>
                                                Thêm mới
                                            </Button>
                                        </Col>
                                    </Row> */}
                                </Form>
                            </Col>
                            <Col span={24}>
                                <br />
                            </Col>
                            <Col xs={24} xl={24} span={24}>
                                <Table rowClassName={(record, index) => {
                                    return index % 2 === 0 ? "gray-color" : "";
                                }} scroll={{ x: 1000 }} size="middle" dataSource={dataOwners} pagination={{ pageSize: 10 }} sticky columns={columnOwners} />
                            </Col>
                        </Row>
                    </TabPane>

                </Tabs>
            </Card>

            <Modal
                width={600}
                onOk={handleOkOwners}
                onCancel={handleCancelOwners}
                open={openModalOwners}
                title={
                    <span>
                        {statusOwners === false ? 'Thêm mới thông tin tổ chức' : 'Cập nhật thông tin tổ chức'}
                    </span>
                }
                footer={[
                    <Button onClick={handleCancelOwners} key="back" >
                        Hủy
                    </Button>,
                    <Button form="form-Owners" type="primary" htmlType="submit" loading={loadingOwners}>
                        Lưu
                    </Button>,
                ]}
            >
                {loadingOwners ? (
                    <>
                        <Skeleton loading={loadingOwners} active />
                    </>
                ) : (
                    <>{renderOwners()}</>
                )}
            </Modal>


        </div >
    )

}
export default CompanyManager;